import React from 'react';
import { COLORS } from '@constants';
import { Tag } from '../ui/Tag';

export const getProductStatus = (status) => {
    switch (status) {
        case 'Connected':
            return <Tag color={COLORS.$robinBlue}>{status}</Tag>;
        case 'Paid':
            return <Tag color={COLORS.$robinBlue}>{status}</Tag>;
        case 'Not Connected':
            return <Tag color={COLORS.$gray40Black}>{status}</Tag>;
        case 'In Review':
            return <Tag color={COLORS.$alert}>{status}</Tag>;
        case 'Rejected':
            return <Tag color={COLORS.$tartRed}>{status}</Tag>;
        case 'Draft':
            return <Tag color={COLORS.$gray40Black}>{status}</Tag>;
        case 'Archived':
            return <Tag color={COLORS.$gray40Black}>{status}</Tag>;
        case 'Open':
            return <Tag color={COLORS.$robinBlue}>{status}</Tag>;
        default:
            return <Tag>{status}</Tag>;
    }
};
